export const picExt = ['.png', '.jpeg', '.webp', '.jpg', '.gif', '.svg'];
export const picType = picExt.map(item => item.substring(1));
export const videoExt = ['.mp4', '.mov', '.avi', '.mpeg', '.wmv', '.rmvb', '.webm'];
export const videoType = videoExt.map(item => item.substring(1));
